import axios from 'axios';

const api = axios.create({
    baseURL: '/',
    withCredentials: true
});

 const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
 
 
 api.defaults.headers.common['X-CSRF-Token'] = csrfToken;

 
export default api;
